import { render, staticRenderFns } from "./ClosingView.vue?vue&type=template&id=f816ba06&scoped=true"
import script from "./ClosingView.vue?vue&type=script&lang=js"
export * from "./ClosingView.vue?vue&type=script&lang=js"
import style0 from "./ClosingView.vue?vue&type=style&index=0&id=f816ba06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f816ba06",
  null
  
)

export default component.exports